import type { Meta, StoryFn } from '@storybook/react';
import type { StatusBadgeProps } from 'components/StatusBadge';

import { StatusBadge } from 'components/StatusBadge';

const codeString = '<InfoBadge highContrast=[boolean]>{label}</InfoBadge>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/StatusBadge',
  component: StatusBadge,
  parameters: {
    inspectComponent: StatusBadge,
    codeString: codeString,
  },
} as Meta<StatusBadgeProps>;

const Template: StoryFn<StatusBadgeProps> = (args) => <StatusBadge {...args} />;

const defaultArgs: StatusBadgeProps = {
  label: 'This is example badge',
  highContrast: false,
};

export const StatusBadgeExample = Template.bind({});

StatusBadgeExample.args = {
  ...defaultArgs,
};
